'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _authentication = require('./authentication.component');

var _authentication2 = _interopRequireDefault(_authentication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authenticationModule = _angular2.default.module('authentication', [_angularUiRouter2.default]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('login', {
    url: '/login',
    template: '<authentication></authentication>',
    authenticate: true
  });
}).component('authentication', _authentication2.default);

exports.default = authenticationModule;


// WEBPACK FOOTER //
// ./client/app/components/authentication/authentication.js